














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({
})
export default class EventItem extends Vue {
  @Prop({default: ''})
  private title!: string;

  @Prop({default: ''})
  private host!: string;

  @Prop({default: ''})
  private price!: string;

  @Prop({default: ''})
  private date!: string;

  @Prop({default: ''})
  private time!: string;

  @Prop()
  private id!: string;

  private handleClick(event: any) {
    this.$emit('click', this.id);
  }
}
